module.exports = __webpack_public_path__ + "static/media/panda-partners-1.855f78a5.svg";